import Confirmation from "../Components/Confirmation/Confirmation";
import config from "../config";
import { submitCaptcha } from "./captcha";
const base_url = config.base_url;
export const RetrieveKey = () => {
  return new Promise((resolve, reject) => {
    fetch(base_url + "user/pay/key", {
      method: "GET",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if (res.success) {
          console.log("Success", res.success);
          resolve(res.success);
        } else {
          throw new Error(res);
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getCountryISO = () => {
  return fetch(base_url + "user/pay/countries", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  });
};
export const showpostalCode = (countries, selectedCountry) => {
  if (countries)
    return (
      countries
        .filter((e) => e?.postal_code)
        .filter((e) => e?.cca2.toLowerCase() == selectedCountry?.toLowerCase())
        .length > 0
    );
  else return false;
};
export const getDefaultPostalCode = (countries, selectedCountry) => {
  if (countries) {
    console.log(
      countries
        .filter((e) => e?.postal_code)
        .filter(
          (e) => e?.cca2.toLowerCase() == selectedCountry?.toLowerCase()
        )[0]?.postal_code
    );
    return countries
      .filter((e) => e?.postal_code)
      .filter((e) => e?.cca2.toLowerCase() == selectedCountry?.toLowerCase())[0]
      ?.postal_code;
  } else return undefined;
};
export const getPostalName = (countries, selectedCountry) => {
  if (countries) {
    console.log(
      countries
        .filter((e) => e?.postal_code)
        .filter(
          (e) => e?.cca2.toLowerCase() == selectedCountry?.toLowerCase()
        )[0]?.postal_code_name
    );
    return countries
      .filter((e) => e?.postal_code)
      .filter((e) => e?.cca2.toLowerCase() == selectedCountry?.toLowerCase())[0]
      ?.postal_code_name;
  } else return undefined;
};
export const getInvoices = () => {
  return fetch(base_url + "user/invoices", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  });
};
export const calculateTaxes = (
  currency,
  country,
  price,
  postal_code,
  message
) => {
  return fetch(base_url + "user/pay/stripe/tax/calculate", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `currency=${currency}&country=${country}&price=${price}&postal_code=${postal_code}&message=${message}`,
  });
};
export const calculateTaxesv2 = (
  amount_total,
  countries,
  country,
  currency
) => {
  const selectedCountry = countries.filter(
    (e) => e.cca2.toLowerCase() === country.toLowerCase()
  )[0];
  const percentage = selectedCountry?.VAT || 0;
  const taxable_amount = Math.floor(amount_total / (1 + percentage / 100));
  const tax_amount = amount_total - taxable_amount;
  return {
    amount_total,
    tax_breakdown: {
      amount: tax_amount,
      inclusive: true,
      tax_rate_details: {
        percentage_decimal: percentage,
      },
      taxability_reason: "not_collecting",
      taxable_amount: taxable_amount,
    },
    currency: currency,
  };
};
export const validateVATNumber = (country_code, value) => {
  return fetch(base_url + "user/pay/stripe/tax/validate", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `country_code=${country_code}&value=${value}`,
  });
};
export const validTaxTypes = (country_code, value) => {
  return fetch(base_url + "user/pay/stripe/tax/ids", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  });
};
export const SetUpIntent = (payment_method = "card") => {
  // The only possible values for payment methods are: 'card' and 'sepa_debit' in Stripe standards
  return new Promise((resolve, reject) => {
    fetch(base_url + "user/pay/intent", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `payment_method=${payment_method}`,
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if (res.success) {
          //We are returnning the client_secret
          resolve(res.success);
        } else {
          throw new Error(res);
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const getStripeCardDetails = () => {
  return fetch(base_url + "user/pay/card", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      credentials: "include",
    },
    credentials: "include",
  });
};
//If confirm is true, we are confirming the setUpintent
//If confirm is false, we are subscribing and then confirming the paymentintent
export const createPaymentMethod = (
  stripe,
  elements,
  billing_details,
  confirm = true
) => {
  const client_secret = elements?._commonOptions?.clientSecret?.clientSecret;
  let payment_method;
  // console.log(client_secret)
  return new Promise(async (resolve, reject) => {
    if (!stripe || !elements) {
      return reject("No stripe and/or element object is provided");
    }
    let paymentMethod;
    await elements.submit();
    stripe
      .createPaymentMethod({
        elements,
        params: {
          billing_details,
        },
      })
      .then((paymentMethod_) => {
        paymentMethod = paymentMethod_;
        if (confirm)
          return stripe.confirmCardSetup(client_secret, {
            payment_method: paymentMethod.paymentMethod.id,
          });
        else return;
      })
      .then((data) => {
        console.log(data);
        if (data?.error) throw new Error(data?.error?.code);
        console.log(paymentMethod);
        resolve(paymentMethod);
      })
      .catch((e) => {
        console.log(e);
        reject();
      });
  });
};
export const createIbanPaymentMethod = (
  stripe,
  iban_number,
  billing_details
) => {
  return new Promise((resolve, reject) => {
    stripe
      ?.createPaymentMethod({
        type: "sepa_debit",
        sepa_debit: {
          iban: iban_number,
        },
        billing_details,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const fetchStripeProducts = () => {
  return fetch(base_url + "user/pay/products", {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  })
    .then((res) => {
      if (res.status !== 200) throw new Error();
      else return res.json();
    })
    .then((data) => {
      console.log(data);

      const newData = {
        ...data,
        products: data.products.map((product) => ({
          ...product,
          metadata: {
            ...product.metadata,
            fr_name:
              product.name === "PAY AND FORGET"
                ? "A VIE"
                : product.metadata.fr_name,
          },
        })),
      };

      return newData;
    })
    .catch((e) => {
      console.log("Error retrieving products");
    });
};
export const updateStripeData = (billingData) => {
  return fetch(base_url + "user/pay/stripe/update", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `email=${billingData.email}&first_name=${billingData.first_name}&last_name=${billingData.last_name}&address=${billingData.address}&vat_company_number=${billingData.vat_company_number}&type=${billingData.type}&country=${billingData.country}&tax_type=${billingData.tax_type}&postal_code=${billingData.postal_code}`,
  });
};
export const cancelStripeSubscription = () => {
  return fetch(base_url + "user/pay/subscription/cancel", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  });
};
export const confirmSubscriptionPayment = (stripe, paymentIntentSecret) => {
  return stripe.confirmCardPayment(paymentIntentSecret);
};
export const validateDiscount = (coupon) => {
  return fetch(base_url + "user/pay/stripe/coupon/validate", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `coupon=${coupon}`,
  });
};
/*
  The currency is sent because a fixed-sum coupon is quoted per currency: the
  route converts `customer_reward_amount` with it and builds
  `amount_off_currencies`. Without it the route cannot price a sum-based code
  at all. Optional, so callers that only care about `percent_off` can omit it.
*/
export const pendingDiscount = (currency) => {
  return fetch(base_url + "user/pay/stripe/coupon/pending", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `currency=${encodeURIComponent(currency || "")}`,
  });
};
export const CheckPaymentSubscription = (plan, currency, referralCode) => {
  return new Promise((resolve, reject) => {
    submitCaptcha()
      .then((token) => {
        const function_ = fetch(base_url + "user/pay/checkPayment", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
          body: `token=${token}&plan=${plan}&currency=${currency}&referralCode=${referralCode}`,
        });
        resolve(function_);
      })
      .catch((e) => {
        console.log(e);
        reject();
      });
  });
};
export const activateAutoRenewal = () => {
  return new Promise((resolve, reject) => {
    fetch(base_url + "user/pay/subscription/activate/renewal", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200) resolve();
        else reject();
      })
      .catch((e) => {
        reject();
      });
  });
};
export const AddSubscription = (plan) => {
  return new Promise((resolve, reject) => {
    const function_ = fetch(base_url + "user/pay/customer/add", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `plan=${plan}`,
    });
    resolve(function_);
  });
};
